// data/MessageTemplates.js
const templates = [
  {
    category: "Business",
    templates: [
      {
        id: "business_1",
        name: "Order Confirmation",
        content: "Dear customer, your order has been confirmed. We'll notify you once it's ready for delivery. Thank you for choosing us!",
      },
      {
        id: "business_2",
        name: "Appointment Reminder",
        content: "Reminder: Your appointment is scheduled for tomorrow at [TIME]. Please arrive 15 minutes early. Contact us if you need to reschedule.",
      },
      {
        id: "business_3",
        name: "Purchase Confirmation",
        content: "Thank you for your purchase! Your order #[ORDER_ID] is being processed and will be delivered within 2-3 business days.",
      },
    ],
  },
  {
    category: "Marketing",
    templates: [
      {
        id: "marketing_1",
        name: "Special Offer",
        content: "Special offer just for you! Get 20% off your next purchase. Use code SAVE20. Valid until [DATE]. Shop now!",
      },
      {
        id: "marketing_2",
        name: "Flash Sale",
        content: "Don't miss out! Our flash sale ends tonight. Up to 50% off selected items. Visit our store or shop online now!",
      },
      {
        id: "marketing_3",
        name: "New Arrivals",
        content: "New arrivals are here! Be the first to explore our latest collection. Visit us today and get a free gift with any purchase.",
      },
    ],
  },
  {
    category: "Personal",
    templates: [
      {
        id: "personal_1",
        name: "Check-in",
        content: "Hi there! Just wanted to check in and see how you're doing. Hope you're having a great day!",
      },
      {
        id: "personal_2",
        name: "Birthday Wishes",
        content: "Happy Birthday! Wishing you all the best on your special day. Hope it's filled with joy and celebration!",
      },
      {
        id: "personal_3",
        name: "Thank You",
        content: "Thank you so much for your help today. I really appreciate your time and support. You're amazing!",
      },
    ],
  },
];

export default templates;